import { AnimationMixer } from 'three';
class Mixers {
    constructor() {
        this._mixers = [];
    }
    /**
     * Create an Animation Mixer and ads it to the mixers array
     */
    animationMixer(root) {
        const mixer = new AnimationMixer(root);
        this.mixers.add(mixer);
        return mixer;
    }
    get mixers() {
        return {
            create: (root) => this.animationMixer(root),
            add: (animationMixer) => this._mixers.push(animationMixer),
            get: () => this._mixers,
            update: (delta) => { var _a; return (_a = this._mixers) === null || _a === void 0 ? void 0 : _a.forEach(mixer => mixer.update(delta / 1000)); }
        };
    }
}
export default Mixers;
//# sourceMappingURL=mixers.js.map